import {
  type Context as HeaderContext,
  useHeaderContext,
} from '@virginexperiencedays/header-2024/src';
import {
  type Context as HeaderContextSlim,
  useHeaderContext as useHeaderContextSlim,
} from '@virginexperiencedays/slim-header';
import { envVariables } from '../../Layout/envVariables';

export const useHandleUpdateBasketCount = () => {
  const headerContextSlim: HeaderContextSlim = useHeaderContextSlim();
  const headerContext: HeaderContext = useHeaderContext();
  const { handleUpdateBasketCount } = envVariables.isSlimHeader ? headerContextSlim : headerContext;

  return handleUpdateBasketCount;
};
